<template>
  <!-- <TopBar class="mb-14" :show-back-button="true" :show-toggle="false"/> -->
  <div>
    <QrCodeReader
      v-if="isCameraEnabled"
      @on-detect="onReadQrCode"
      class="mx-auto mb-14 h-full w-full"
    />
  </div>

</template>

<script setup lang="ts">
import QrCodeReader from '@/components/QrCodeReader/QrCodeReader.vue'
import { ScanInputType, useAppStore } from '@/stores/app.store'
import { computed } from 'vue'
import { debounce } from 'lodash'

const appStore = useAppStore()

const emit = defineEmits(['tag'])

const isCameraEnabled = computed(() => appStore.scanInputType === ScanInputType.CAMERA)

const debouncedEmitTag = debounce((code: string) => {
  emit('tag', code)
}, 500, { leading: true, trailing: false })

function onReadQrCode(code: string) {
  debouncedEmitTag(code)
}
</script>
